


















import Vue from 'vue';

import { breakpointsMixin } from '@/mixins/breakpoints';
import { iconsMixin } from '@/mixins/icons';

export default Vue.extend<any, any, any, any>({
  mixins: [breakpointsMixin, iconsMixin],
  methods: {},
});
